import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContextMenuItem } from './context-menu-item.model';

@Component({
    selector: 'diana-context-menu',
    templateUrl: './context-menu.component.html',
    styleUrls: ['./context-menu.component.scss'],
    standalone: false
})
export class ContextMenuComponent {
  @Input()
  menuItems: ContextMenuItem[] = [];

  @Input()
  menuColor: string = '#757575';

  @Input()
  xPosition: 'before' | 'after' = 'before';

  @Input()
  yPosition: 'below' | 'above' = 'below';

  @Output()
  itemSelected = new EventEmitter<string>();

  onItemSelected(item: ContextMenuItem) {
    if (item?.id) {
      this.itemSelected.emit(item.id);
    }
  }

  trackById(index: number, item: ContextMenuItem) {
    if (item.id) {
      return item.id;
    }

    return index;
  }
}
